module.exports = __webpack_public_path__ + "img/Icon_Mind2_Teil_II_RZ_rgb.3e37dee5.png";